// https://webpack.js.org/guides/dependency-management/#requirecontext
const pricingapiFiles = require.context('./pricingapi', true, /\.js$/)
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const pricingapi = pricingapiFiles.keys().reduce((pricingapi, apiPath) => {
    // set './app.js' => 'app'
    const apiName = apiPath.replace(/^\.\/(.*)\.\w+$/, '$1')

    const value = pricingapiFiles(apiPath)

    pricingapi[apiName] = value.default

    return pricingapi
}, {})
export default pricingapi